const MESSAGES_KEY = 'arthelper_public_messages';

interface StoredMessages {
  chatId: string;
  messages: any[];
  savedAt: string;
}

export const publicChat = {
  save: (chatId: string, messages: any[]): void => {
    if (messages.length === 0) {
      return;
    }

    const data: StoredMessages = {
      chatId,
      messages,
      savedAt: new Date().toISOString(),
    };

    localStorage.setItem(MESSAGES_KEY, JSON.stringify(data));
  },

  getForConversion: (): StoredMessages | null => {
    const stored = localStorage.getItem(MESSAGES_KEY);

    if (!stored) {
      return null;
    }

    return JSON.parse(stored);
  },

  clear: (): void => {
    localStorage.removeItem(MESSAGES_KEY);
  },
};
